import { Box } from '@veracity/vui'

import { PageContainer, PageSearchInput } from '@/components'
import { useCurrentUser, useFilterDatasets } from '@/hooks'

import { AddFinancesDatasetDialog, FinancesDatasetsTable } from './components'
import { useFinanceDatasets } from './hooks'

export const FinancesPage = () => {
  const { isUser } = useCurrentUser()
  const { financeDatasets, isFetching } = useFinanceDatasets()
  const { filteredDatasets, onFilterChange } =
    useFilterDatasets(financeDatasets)

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs
          items={[{ title: 'Library' }, { title: 'Finances' }]}
        />
      }
      menuBar={
        <Box justify="space-between" w="100%">
          <PageSearchInput onChange={onFilterChange} />
          {isUser && <AddFinancesDatasetDialog />}
        </Box>
      }>
      <FinancesDatasetsTable datasets={filteredDatasets} />
    </PageContainer>
  )
}
